import { render, staticRenderFns } from "./IUserMultiPicker.vue?vue&type=template&id=004615b3"
import script from "./IUserMultiPicker.vue?vue&type=script&lang=js"
export * from "./IUserMultiPicker.vue?vue&type=script&lang=js"
import style0 from "./IUserMultiPicker.vue?vue&type=style&index=0&id=004615b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports